"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EligibilityUpdateEvent = void 0;
const eligibility_event_type_1 = require("../enums/eligibility-event-type");
class EligibilityUpdateEvent {
    constructor(_requirements, _updatedRequirements) {
        this.eventType = EligibilityUpdateEvent.EventType;
        this.timestamp = new Date();
        this.currentRequirements = _requirements;
        this.updatedRequirements = _updatedRequirements;
    }
}
exports.EligibilityUpdateEvent = EligibilityUpdateEvent;
EligibilityUpdateEvent.EventType = eligibility_event_type_1.EventType.ELIGIBILITY_UPDATE;
